// Copyright (c) 2016 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.normal.claim,
    formValidation: state.claims.normal.formValidation,
    isEditable: state.claims.normal.isEditable,
    isValidClaim: state.claims.normal.isValidClaim,
    ownershipStatus: state.claims.ownershipStatus,
    product: state.claims.normal.product,
    rgaStatus: state.claims.normal.rgaStatus,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    updateShowApplyTravel: state.claims.normal.updateShowApplyTravel
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/normal/components/claim-details-section/index.js